/** @format */

import {useState} from 'react';

import {Box, ButtonBase, Typography} from '@mui/material';
import {Trans, useTranslation} from 'react-i18next';

import {VariantType} from '../model/types';
import {StyledRightColumn, StyledRow, useSensorBarCategoriesStyles} from './styles';

export interface SensorBarCategoriesProps {
  description: string;
  title: string;
  icon: string;
  total: number;
  totalNew: number;
  sensors: number;
  variant: VariantType;
  onClick?: () => void;
}

const SensorBarCategories = (props: SensorBarCategoriesProps) => {
  const [hover, setHover] = useState<boolean>(false);

  const {description, total, totalNew, title, icon, variant, sensors, onClick} = props;

  const classes = useSensorBarCategoriesStyles();
  const {t} = useTranslation();

  return (
    <StyledRow hover={hover}>
      <ButtonBase
        component='a'
        className={classes.content}
        onClick={onClick}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        disableRipple
      >
        <Box className={classes.contentLeftColumn}>
          <Box className={classes.headingBox}>
            <Box className={classes.headingIconAndText}>
              <Box className={classes.iconBox}>
                <img alt='category icon' src={icon} />
              </Box>
              <Typography className={classes.title}>{title}</Typography>
            </Box>
            <Typography className={classes.description}>
              {t('plurals.sensors', {count: sensors})}
            </Typography>
          </Box>
          <Typography className={classes.description}>{description}</Typography>
        </Box>

        <StyledRightColumn colorScheme={variant}>
          {total === 0 ? (
            <Typography className={classes.recommendationsText}>
              <Trans>Рекомендаций нет</Trans>
            </Typography>
          ) : (
            <>
              <Typography className={classes.recommendationsText}>{total}</Typography>
              <Typography className={classes.recommendationsText}>
                ({totalNew > 0 ? '+' : ''}
                {totalNew} новых)
              </Typography>
            </>
          )}
        </StyledRightColumn>
      </ButtonBase>
    </StyledRow>
  );
};

export default SensorBarCategories;
